import { Briefcase } from 'lucide-react';
import { cn } from '../../../../utils/type';

interface BecomeProviderButtonProps {
  onClick: () => void;
  className?: string;
}

const BecomeProviderButton = ({
  onClick,
  className,
}: BecomeProviderButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'group relative inline-flex items-center gap-1.5 rounded-full px-2.5 sm:px-3 py-1 text-[11px] sm:text-xs font-semibold text-white',
        'shadow-[0_4px_14px_-6px_color-mix(in_oklab,var(--primary)_55%,transparent)]',
        'transition-all duration-300 hover:-translate-y-px hover:shadow-[0_6px_18px_-8px_color-mix(in_oklab,var(--primary)_70%,transparent)]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        className
      )}
      style={{ background: 'var(--gradient-primary)' }}
    >
      <span className="pointer-events-none absolute inset-0 overflow-hidden rounded-full">
        <span className="absolute inset-y-0 left-0 w-1/3 -skew-x-12 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-provider-shimmer group-hover:via-white/50" />
      </span>

      <span className="relative grid h-4 w-4 place-items-center rounded-full bg-white/20 backdrop-blur-sm">
        <Briefcase className="h-2.5 w-2.5" strokeWidth={2.5} />
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping opacity-30" />
      </span>

      <span className="relative">Become a Provider</span>
    </button>
  );
};

export default BecomeProviderButton;
